import React, { useState, useEffect, useRef } from 'react';
import { alert_error, alert_success } from '../AppContext';
import axios from 'axios';
import { Cookies } from '../index.js';
import Language_i18 from '../js/useNationalLanguage.jsx';
import { ClipLoader } from 'react-spinners';
import LazyGeeTest from "../app_structure/LazyGeeTest.jsx";

// Tất cả text UI đều nằm ở đây
const translations = {
  vi: {
    reload: "Tải lại trang",
    login: "Đăng nhập",
    confirm: "Xác nhận",
    loading_captcha: "Please wait a moment 😊 đang tải captcha",
    robot_prompt: "Hãy tích vào ô xác nhận nhé",
    processing_wait: "Bạn hãy đợi vài giây để app xử lý nhé",
    retry_error: "Xin lỗi vì sự cố bạn hãy thử lại nhé",
    thank_you: "Hust Media cảm ơn bạn rất nhiều",
    server_error: "Lỗi máy chủ vui lòng tải lại trang",
    captcha_fail: "Đã xảy ra lỗi tải lại trang nhé"
  },
  en: {
    reload: "Reload page",
    login: "Login",
    confirm: "Confirm",
    loading_captcha: "Please wait a moment, loading captcha…",
    robot_prompt: "Please check the “verify” box",
    processing_wait: "Please wait a few seconds while we process",
    retry_error: "Sorry, something went wrong—please try again",
    thank_you: "Thank you from Hust Media!",
    server_error: "Server error, please reload the page",
    captcha_fail: "Captcha failed, please reload"
  }
};

function Singup() {
  const { lang } = Language_i18();

  const [showCaptcha, setShowCaptcha] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [buttonTextjop, setbuttonTextjop] = useState(translations[lang]?.confirm);
  const [loading, setLoading] = useState(true);
  const [chedo, setchedo] = useState('');
  const [geetoken, setgeetoken] = useState('');
  const [nutxuly, setnutxuly] = useState(0);
  const captchaRef = useRef(null);
  const [disabledbutton, setdisabledbutton] = useState(true);
  const national_market = Cookies.get('national_market');
  function reloadPage() {
    window.location.reload();
  }

  function testFunction(response) {
    const info = response.data;
    setnutxuly(0);

    if (info.status == 0) {
      alert_error(info.message);
      setbuttonTextjop(translations[lang]?.retry_error);
      captchaRef.current?.reset();
    }
    else if (info.status == 1) {
      const expiry = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);
      Cookies.set('apikey', info.apikey, { expires: expiry });
      alert_success(info.message);
      setbuttonTextjop(translations[lang]?.thank_you);
    }
    else {
      alert_error(translations[lang]?.server_error);
    }

    if (info.redirect) {
      setTimeout(() => window.location.href = info.redirect, 1500);
    }
  }

  const handleGeetestSuccess = (value) => {
    setgeetoken(value);

    if (value.captcha_output.length > 200) {
      setnutxuly(1);
      setbuttonTextjop(translations[lang]?.processing_wait);

      const payload = JSON.stringify({
        geetoken: value,
        national_market: national_market,
        domain: window.location.hostname,
        chedo,
        device_id: Cookies.get("device_id"),
        device_type: Cookies.get("device_type"),
        category: 'random'
      });

      axios.post('https://hust.media/api/auth/signup.php', payload, {
        headers: { 'Content-Type': 'application/json' }
      })
        .then(testFunction)
        .catch(err => {
          alert_error(err);
          setnutxuly(0);
          captchaRef.current?.reset();
        });
    } else {
      setbuttonTextjop(translations[lang]?.captcha_fail);
    }
  };

  useEffect(() => {
    setbuttonTextjop(translations[lang]?.loading_captcha);
    setIsLoading(true);

    setTimeout(() => {
      setShowCaptcha(true);
      setIsLoading(false);
      setbuttonTextjop(translations[lang]?.robot_prompt);
    }, 2900);

    setLoading(false);

    const mode = new URL(window.location.href).searchParams.get('chedo');
    setchedo(mode == 'native' ? 'native' : 'signup');
  }, [lang]);

  return (
    <div>
      <div className="max-w-2xl px-1 py-1 mx-auto rounded-lg shadow-xl">
        <div className="container-fluid">
          <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">
            <ClipLoader color="#fff" loading={loading} size={150} />

            {!loading && (
              <form className="add-form">
                <div className="form-control">
                  {isLoading && (
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  )}

                  {showCaptcha && (
                    <LazyGeeTest
                      captchaRef={captchaRef}
                      geetoken={geetoken}
                      handleGeetestSuccess={handleGeetestSuccess}
                      captchaId="2367e368fef71fff0bf119f963985786"
                      containerId="fecfead39968d5617f9a50a9bde75c48"
                    >
                      {!geetoken ? (
                        <button
                          type="button"
                          className="mt-1 rounded-md border border-gray-400 px-3 py-2 text-sm"
                        >
                          {translations[lang]?.robot_prompt}
                        </button>
                      ) : null}
                    </LazyGeeTest>
                  )}

                  <button
                    disabled={disabledbutton}
                    className="flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-3 w-full dark:bg-slate-800 dark:text-white"
                  >
                    <div className="flex items-center justify-between flex-1">
                      {nutxuly == 1 && <div className="spinner-border" role="status"></div>}
                      <span className="text-lg font-medium text-white">
                        {buttonTextjop}
                      </span>
                      <div className="text-xl">{'\u27A4'}</div>
                    </div>
                  </button>
                </div>
              </form>
            )}

            {showCaptcha && (
              <>
                <button
                  type="button"
                  onClick={reloadPage}
                  className="btn-sm btn-outline-secondary"
                >
                  {translations[lang]?.reload}
                </button>
                <a href="/shop/auth/login_home">
                  <button type="button" className="btn-sm btn-outline-secondary">
                    {translations[lang]?.login}
                  </button>
                </a>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Singup;
